import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

//import material ui
import {
  Button,
  Card,
  Divider,
  Grid,
  TextField,
  Typography,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  FormHelperText,
  Link,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import { useTheme } from "@mui/material/styles";

//project components
import CompanyLogo from "../../../assets/images/HeaderLogo.jpeg";
import { setUser } from "../../../store/userSlice";

//third party
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "../../../api";

const validationSchema = yup.object({
  firstName: yup
    .string()
    .max(50, "Must be 50 characters or less ")
    .required("Required"),
  middleName: yup.string().max(50, "Must be 50 characters or less "),
  lastName: yup
    .string()
    .max(50, "Must be 50 characters or less ")
    .required("Required"),
  dateOfBirth: yup
    .date()
    .min(new Date("01-01-1950"))
    .max(new Date())
    .required(),
  phoneNumber: yup
    .string()
    .required("Required")
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid",
    )
    .max(10, "Max 10 digits are allowed"),
  city: yup.string().max(50, "Must be 50 characters or less "),
  aadharNumber: yup.string().max(12, "Must be 12 characters or less "),
  email: yup
    .string("Enter your email")
    .max(50, "Must be 50 characters or less ")
    .email("Enter a valid email")
    .required("Email is required"),
});

const salutationOptions = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
  { value: "Miss.", label: "Miss." },
  { value: "Dr.", label: "Dr." },
];
const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];
const SignUp = () => {
  const theme = useTheme();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [tandcAccepted, setTandCAccepted] = useState(false);
  const [openTermsDlg, setOpenTermsDlg] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      salutation: "Mr.",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      gender: "Male",
      dateOfBirth: new Date().toISOString().split("T")[0],
      phoneNumber: "",
      city: "",
      aadharNumber: "",
    },
    validationSchema: validationSchema,
    // onSubmit: (values) => {
    //   setSubmitting(true);
    //   axios
    //     .post("/api/Users/CheckEmailExists?email=" + values.email)
    //     .then((response) => {
    //       if (response.status === 200) {
    //         if (response.data == false) {
    //           SignUp(values);
    //         } else {
    //           alert(
    //             "The email: " +
    //               values.email +
    //               "already exists, please sign in with this email instead."
    //           );
    //           setSubmitting(false);
    //         }
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       setSubmitting(false);
    //     });
    // },
    onSubmit: (values) => {
      setSubmitting(true);
      SignUp(values);
    },
  });

  const SignUp = async (values) => {
    try {
      const response = await axios.post(
        "/api/Authentication/candidate-sign-up",
        values,
      );
      if (response.status === 200 && response.data?.accessToken) {
        localStorage.setItem("accessToken", response.data.accessToken);

        dispatch(setUser(response.data));

        navigate("/profile?ref=" + response.data.profileId);
      } else {
        alert(response.data?.message || "Signup failed.");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  console.log("rendering signup", formik.values, formik.errors);
  return (
    <Card elevation={4}>
      <Grid container>
        <Grid
          item
          sm={5}
          xs={12}
          sx={{
            //bgcolor: "#e3f2fd",
            paddingX: 2,
            paddingY: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={CompanyLogo} alt="company-logo" width="80%" />
        </Grid>
        <Grid
          item
          sm={7}
          sx={{
            padding: 4,
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{ marginBottom: 2, textAlign: "center" }}
            variant="h4"
            color="primary.dark"
          >
            Sign Up
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item sm={12} xs={12}>
                <Divider />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  fullWidth
                  select
                  name="salutation"
                  label="Salutation"
                  value={formik.values.salutation}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.salutation &&
                    Boolean(formik.errors.salutation)
                  }
                  helperText={
                    formik.touched.salutation && formik.errors.salutation
                  }
                >
                  {salutationOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="First Name *"
                  name="firstName"
                  type="text"
                  fullWidth
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.firstName && Boolean(formik.errors.firstName)
                  }
                  helperText={
                    formik.touched.firstName && formik.errors.firstName
                  }
                ></TextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Middle Name"
                  name="middleName"
                  type="text"
                  fullWidth
                  value={formik.values.middleName}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.middleName &&
                    Boolean(formik.errors.middleName)
                  }
                  helperText={
                    formik.touched.middleName && formik.errors.middleName
                  }
                ></TextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Last Name *"
                  name="lastName"
                  type="text"
                  fullWidth
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.lastName && Boolean(formik.errors.lastName)
                  }
                  helperText={formik.touched.lastName && formik.errors.lastName}
                ></TextField>
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  select
                  name="gender"
                  label="Gender"
                  value={formik.values.gender}
                  onChange={formik.handleChange}
                  error={formik.touched.gender && Boolean(formik.errors.gender)}
                  helperText={formik.touched.gender && formik.errors.gender}
                >
                  {genderOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  name="dateOfBirth"
                  type="date"
                  label="Date of Birth *"
                  fullWidth
                  value={formik.values.dateOfBirth}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.dateOfBirth &&
                    Boolean(formik.errors.dateOfBirth)
                  }
                  helperText={
                    formik.touched.dateOfBirth && formik.errors.dateOfBirth
                  }
                ></TextField>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  name="phoneNumber"
                  label="Mobile Number *"
                  onChange={formik.handleChange}
                  value={formik.values.phoneNumber}
                  fullWidth
                  error={
                    formik.touched.phoneNumber &&
                    Boolean(formik.errors.phoneNumber)
                  }
                  helperText={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="City"
                  name="city"
                  type="text"
                  fullWidth
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="email"
                  label="Email Address *"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  fullWidth
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>
              {/* <Grid item sm={12} xs={12}>
                <Divider />
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  name="aadharNumber"
                  label="Aadhaar Number"
                  onChange={formik.handleChange}
                  value={formik.values.aadharNumber}
                  fullWidth
                  error={
                    formik.touched.aadharNumber &&
                    Boolean(formik.errors.aadharNumber)
                  }
                  helperText={
                    formik.touched.aadharNumber && formik.errors.aadharNumber
                  }
                />
              </Grid>

              <Grid item sm={12} xs={12}>
                <Divider />
              </Grid>
              <Grid item sm={12} xs={12}>
                <LoadingButton
                  variant="contained"
                  //disabled={!tandcAccepted}
                  type="submit"
                  fullWidth
                  loading={submitting}
                  startIcon={<HowToRegIcon />}
                  loadingPosition="end"
                  size="large"
                  color="secondary"
                >
                  Sign Up
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <Dialog
        open={openTermsDlg}
        onClose={() => {
          setOpenTermsDlg(false);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Terms & Conditions</DialogTitle>
        <DialogContent>List of terms & Conditions</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenTermsDlg(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default SignUp;
